import { Button } from '@material-ui/core';
import ModuleContext from 'CMFW/context/ModuleContext';
import { useForceRender } from 'hooks/useForceRender';
import ConceptUseModel from 'models/ConceptUseModel';
import React, { useCallback, useContext, useMemo } from 'react';
import styled from 'styled-components';
import Grid from 'CMFW/grid/Grid';
import { IFields } from 'CMFW/grid/fields';
import DialectSelect, { IDialectOption } from '../../components/selects/DialectSelect';

type IProps = {
  dialectId: number;
};

export const ConceptUse: React.FC<IProps> = (props) => {
  const forceRender = useForceRender();
  const module = useContext(ModuleContext);
  const { courseId, ref, itemId } = module;

  const [dialectSelect, setDialectSelect] = React.useState(0);

  const usesModel = useMemo(
    () => new ConceptUseModel({ render: forceRender, courseId, ref, refId: itemId, targetDialectId: props.dialectId }),
    [forceRender, courseId, ref, itemId, props.dialectId],
  );

  const handleLoad = useCallback(() => {
    usesModel.getUses(dialectSelect);
  }, [usesModel, dialectSelect]);

  const handleDialectChange = (dialect: IDialectOption) => {
    setDialectSelect(dialect.dialectId);
  };

  const cellRenderers = useMemo(
    () => ({
      [IFields.moduleNavigation]: 'moduleNavigationRenderer',
    }),
    [],
  );

  return (
    <Container>
      <EditorRow>
        <DialectSelect onlySource handleDialectChange={handleDialectChange} />
        <Button variant="outlined" size="small" onClick={handleLoad}>
          load
        </Button>
      </EditorRow>
      <ModuleContext.Provider value={usesModel}>
        <GridStyled cellRenderers={cellRenderers} />
      </ModuleContext.Provider>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const GridStyled = styled(Grid)`
  && {
    height: calc(100% - 30px);
  }
`;

const EditorRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  margin-bottom: 5px;
  & > div {
    margin: 0 10px;
  }
`;
